import { ComponentType } from 'react';
import { TestComponent } from './components/testComponent';
import { InfoBox } from './components/infoBox';
import { Link } from './components/link';
import { RelatedArticles } from './components/relatedArticles';
import { SubArticles } from './components/subArticles';
import { Quickguide } from './components/quickguide';
import { Accordion } from './components/accordion';
import { ImageRow } from './components/imageRow';
import { ImagewithCaption } from './components/imageWithCaption';

interface Registry {
  [name: string]: ComponentType<unknown>;
}

export const registry = {
  TestFredrikW: TestComponent,
  InfoBox,
  Link,
  Accordion,
  ImageRow,
  RelatedArticles,
  SubArticles,
  Quickguide,
  ImagewithCaption
} as Registry;
